<template>
    <svg
      id="Capa_1"
      data-name="Capa 1"
      xmlns="http://www.w3.org/2000/svg"
      :viewBox="viewbox"
    :height="height"
    :width="width"
      
    >
      <polygon
        class="cls-1"
        points="3.78 15.98 13.85 20.57 25.59 16.76 25.59 5.98 15.81 3.32 3.82 5.65 3.78 15.98"
      />
      <polyline class="cls-1" points="3.82 5.65 13.81 9.13 25.59 5.98" />
      <line class="cls-1" x1="13.81" y1="9.13" x2="13.85" y2="20.57" />
      <polyline class="cls-1" points="6.96 17.39 6.96 6.8 19.18 4.32" />
      <polyline class="cls-1" points="10.15 18.76 10.15 7.83 22.33 5.09" />
      <polyline class="cls-2" points="17.78 19.24 17.78 8.17 7.74 4.8" />
      <polyline class="cls-2" points="21.52 18.02 21.52 7.06 11.89 4.09" />
      <polyline class="cls-2" points="3.71 12.76 13.78 16.72 25.55 13.39" />
      <polyline class="cls-2" points="3.71 9.24 13.85 12.95 25.59 9.69" />
      <polyline
        class="cls-2"
        points="3.78 15.43 0.89 16.24 0.89 18.5 13.85 24.72 29.11 19.2 29.11 16.65 25.52 15.91"
      />
      <polyline class="cls-2" points="0.89 16.24 13.81 22.31 29.11 16.65" />
      <line class="cls-2" x1="13.85" y1="24.72" x2="13.85" y2="22.31" />
      <polyline
        class="cls-2"
        points="1.22 18.57 1.22 20.43 3.22 21.39 6.33 21.13"
      />
      <polyline
        class="cls-2"
        points="6.3 21.17 6.3 23.02 8.3 23.98 11.41 23.72 11.81 23.76"
      />
      <line class="cls-2" x1="3.22" y1="21.39" x2="3.22" y2="19.65" />
      <polyline
        class="cls-2"
        points="11.37 23.5 11.37 25.57 13.63 26.68 28.81 20.94 28.81 19.28"
      />
      <line class="cls-2" x1="13.63" y1="26.68" x2="13.56" y2="24.61" />
      <line class="cls-2" x1="8.3" y1="23.98" x2="8.3" y2="22.05" />
    </svg>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["dataUser"]),
  },
  props: {
    color: {
      type: String,
      default: "#00000",
    },
    height: {
      type: Number,
      default: 30,
    },
    width: {
      type: Number,
      default: 30,
    },
    viewbox: {
      type: String,
      default: "0 -3 30 30",
    },
  },
};
</script>

<style scoped>
.cls-1,
.cls-2 {
  fill: none;
  stroke: #000000;
  stroke-linejoin: round;
  stroke-width: 0.45px;
}
.cls-1 {
  stroke-linecap: round;
}
</style>